<form [formGroup]="form" #formDirective="ngForm">
  <div class="card card-body">
    <div class="row">
      <div class="col-sm-11 col-xl-6 col-xxl-4">
        <lib-autocomplete
          #selecaoGrupoCarteiraAutocomplete
          (selectionChanged)="grupoCarteiraSelecionada($event)"
          [schema]="grupoCarteiraSchema"
        ></lib-autocomplete>
      </div>
    </div>
  </div>
</form>
